<template>
  <v-container fluid class="pl-12 pr-12 indigo lighten-5">
    <v-row>
      <p
        :class="
          montantLigne > 0 ? 'color_warning--text' : 'color_success--text'
        "
        class="ml-2 test"
      >
        <span class="mr-2">reste</span>{{ montantLigne }} &euro;
      </p>
      <v-spacer />
      <v-checkbox
        v-model="ligne.facturette"
        :disabled="!user.is_dr || !modify_ligne"
        @change="updateLigne()"
      >
        <template #label>
          <span>{{ $t("ligneRob.facturette") }}</span>
        </template>
      </v-checkbox>
      <v-spacer />

      <v-checkbox
        :disabled="!modify_ligne"
        v-if="user.is_cancel_ligne"
        v-model="ligne.annule"
        @change="updateLigne()"
      >
        <template #label>
          <span>{{ $t("ligneRob.annule") }}</span>
        </template>
      </v-checkbox>
    </v-row>
  </v-container>
</template>

<script>
import { userMixin } from "@/mixins/user";

export default {
  name: "Vue_ShowAttrLigne",
  mixins: [userMixin],
  data() {
    return {
      ligne: {},
    };
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    montantLigne: {
      type: Number,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
    modify_ligne: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    updateLigne() {
      this.$emit("input", this.ligne);
    },
  },
  watch: {
    value() {
      this.ligne = { ...this.value };
    },
  },
  mounted() {
    this.ligne = { ...this.value };
  },
};
</script>

<style scoped>
.test {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 7px;
}
</style>
